import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatModal } from "blocks-nextjs/blocks-react/components/Modal/Modal";
import { CatTextPassage } from "blocks-nextjs/blocks-react/components/TextPassage/TextPassage";
import { useNavigate } from "react-router-dom";
import { CaasRoute } from "../../routes";
import { useCreateProjectMutate } from "../../services/query/create-project-api.query";
import useGlobalStore from "../../store/useGlobalStore";
import useNewProjectStore from "../../store/useNewProjectStore";
import { Variant } from "../GlobalNotification/GlobalNotification";
const NewProjectModal = (props) => {
    const { onModalClose, showModal } = props;
    const navigate = useNavigate();
    const { coordinates, modeType, projectAddress, projectName, projectOwner, projectStatus, setReset } = useNewProjectStore((state) => ({
        coordinates: state.coordinates,
        modeType: state.modeType,
        projectAddress: state.projectAddress,
        projectName: state.projectName,
        projectOwner: state.projectOwner,
        projectStatus: state.projectStatus,
        setReset: state.setReset
    }));
    const { setGlobalNotification, setLastProjectStatus, userPartyNumber } = useGlobalStore((state) => ({
        setGlobalNotification: state.setGlobalNotification,
        setLastProjectStatus: state.setLastProjectStatus,
        userPartyNumber: state.userPartyNumber
    }));
    const { mutate } = useCreateProjectMutate(userPartyNumber);
    const onSubmitModal = (formData) => {
        mutate(formData, {
            onError: () => {
                setGlobalNotification({
                    message: `Creating new project ${projectName} has failed.Please try later`,
                    showNotification: true,
                    type: Variant.error
                });
                navigate(CaasRoute.Home);
            },
            onSuccess: () => {
                setGlobalNotification({
                    message: `New project ${projectName} created in pending state`,
                    showNotification: true,
                    type: Variant.success
                });
                navigate(CaasRoute.Home);
            }
        });
    };
    return (_jsxs(CatModal, { disableBackdropClick: true, heading: "Are you sure", headingVariant: "title", isActive: showModal, onBlModalClose: () => {
            onModalClose(false);
        }, size: "sm", children: [modeType === "create" && (_jsxs("div", { children: [_jsx(CatTextPassage, { size: "sm", slot: "default", children: _jsxs("div", { children: [_jsx(CatHeading, { level: "h6", children: `Save ${projectName} for later` }), _jsx("p", { className: "mt-5", "data-test": "save-modal-paragraph", children: "This will save your project in the pending tab of the Projects Home page so you can complete it later." })] }) }), _jsxs("div", { className: "flex gap-3 mt-5", slot: "footer", children: [_jsx(CatButton, { "data-test": "save-modal-button", onClick: () => {
                                    onSubmitModal({
                                        owner: projectOwner,
                                        projectAddress,
                                        projectName,
                                        ...(coordinates && coordinates?.length !== 0
                                            ? { coordinates: [coordinates[0].lng, coordinates[0].lat] }
                                            : {})
                                    });
                                    onModalClose(false);
                                }, variant: "primary", children: "Save" }), _jsx(CatButton, { "data-test": "discard-modal-button", onClick: () => {
                                    setReset();
                                    onModalClose(false);
                                    navigate(CaasRoute.Home);
                                }, variant: "primary", children: "Discard" }), _jsx(CatButton, { "data-test": "cancel-modal-button", onClick: () => {
                                    onModalClose(false);
                                }, variant: "ghost", children: "Cancel" })] })] })), modeType === "update" && (_jsxs("div", { children: [_jsx(CatTextPassage, { size: "sm", slot: "default", children: projectStatus === "pending"
                            ? "Leaving this page will result in saving project in pending state. Do you wish to leave this page?"
                            : "Do you wish to leave this page?" }), _jsxs("div", { className: "flex justify-end gap-3 mt-6", slot: "footer", children: [_jsx(CatButton, { "data-test": "leave-page-modal-button", onClick: () => {
                                    setLastProjectStatus(projectStatus === "PENDING" ? "Pending" : "");
                                    setReset();
                                    onModalClose(false);
                                    navigate(CaasRoute.Home);
                                }, variant: "ghost", children: "Leave page" }), _jsx(CatButton, { "data-test": "leave-page-modal-cancel-button", onClick: () => {
                                    onModalClose(false);
                                }, variant: "primary", children: "Cancel" })] })] }))] }));
};
export default NewProjectModal;
